import React, { useEffect } from "react";
import { TOptionValue } from "../../optionsUtils";

import "./Radio.scss";

interface IProps {
    value?: TOptionValue;
    onClick?: (e: any) => void;
    disabled?: boolean;
}

export default function Radio(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue | string>(props.value || "unselected");

    const onClick = (e) => {

        if (props.disabled) {
            return;
        }

        if (props.onClick) {
            props.onClick(e);

            return;
        }

        // Radios must always keep one option selected; clicking an already
        // selected radio should not unselect it.
        if (value !== "selected") {
            setValue("selected");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <button
            disabled={props.disabled}
            onClick={onClick}
            type="button"
            className={`userful-radio ${
                value === "selected"
                    ? "userful-radio-selected"
                    : value === "indeterminate"
                      ? "userful-radio-indeterminate"
                      : ""
            }`}
        >
            <div className="userful-radio-element"></div>
        </button>
    );
}
